










import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class RoleSelect extends Vue {
  @Prop({ required: true })
  private value!: string

  private get roles() {
    const rs: Array<{ value: string; text: string }> = []
    if (this.$auth.isAdmin) {
      rs.push({ value: 'ADMIN', text: this.$tc('users.roles.ADMIN') })
    }
    if (this.$auth.isAdmin || this.$auth.isTenant) {
      rs.push({ value: 'TENANT', text: this.$tc('users.roles.TENANT') })
    }
    rs.push({ value: 'USER', text: this.$tc('users.roles.USER') })
    return rs
  }

  private role: string = this.value

  @Watch('value')
  private valueChanged(val: string, old: string) {
    if (val !== old) {
      this.role = val
    }
  }

  @Watch('role')
  private roleChanged(val: string, old: string) {
    this.$emit('input', val)
  }
}
